export enum ZipcodeSearchErrors {
  ZIPCODE_NOT_FOUND = 'ZIPCODE_NOT_FOUND',
  INVALID_ZIPCODE = 'INVALID_ZIPCODE',
}
